<template>
    <div class="course-card" :style="`background-image: url(${course.image});`">
        <div class="inner">
            <div class="specs">
                <div class="line">
                    {{ course.short_tag }}
                </div>
            </div>
            <div class="actions">
                <a @click="launchCourse()" class="btn btn-success d-flex align-items-center mb-2 mx-2" target="_new">
                    <span class="ml-2">View Course</span>
                </a>
            </div>
            <div class="caption">
                <h6>{{ course.name }}</h6>
                <p class="mb-0">{{ course.description }}</p>
            </div>
        </div>
    </div>

</template>

<script>
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import IconClock from "@/Icons/IconClock";
import IconCheck from "@/Icons/IconCheck";
import IconVideo from "@/Icons/IconVideo";
import Modal from "@/Components/Common/Modal";
import mixpanel from "mixpanel-browser";

export default {
    name: "CourseCard",
    mixins: [utils, uploads],

    props: {
        course: {
            type: Object,
        },
    },

    data(){
        return {
            preview: false,
        };
    },

    methods: {
        launchCourse() {
            mixpanel.track('COURSE/VIEW', {course: this.course.short_name});
            window.open('/app/thinkific?course=' + this.course.short_name);
        }
    },

    computed: {

    },

    mounted() {
        
    }

}
</script>

<style lang="scss" scoped>
.course-card{
    background: transparent no-repeat 50%/cover;
    border-radius: 19px;
    border: 6px solid #fff;
    box-shadow: 0 3px 8px rgb(0 0 0 / 16%);
    position: relative;
    height: 480px;
    // margin-left: 1rem;

    &:hover{
        .inner{
            background: rgba($primary, .9);
        }

        .actions{
            opacity: 1;
        }
    }

    &.video{
        .caption{
            .icon{
                background: $secondary;
            }
        }
    }


    &.featured{
        .special{
            left: auto;
            right: -16px;
        }
        .specs{
            left: -16px;
            right: auto;
        }
    }


    &.locked{
        cursor: not-allowed;

        .lock{
            display: flex;
        }
        .caption{
            opacity: .7;
        }
    }
}

.lock{
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    background: rgba(white, .7);
    border-radius: .8rem;
    align-items: center;
    justify-content: center;

    img{
        width: 5rem;
        height: auto;
    }
}

.inner{
    position: absolute;
    top: -6px;
    right: -6px;
    bottom: -6px;
    left: -6px;
    border-radius: 18px;
    border: 6px solid transparent;
    transition: background .3s,border .3s;

    .line{
        display: flex;
        align-items: center;
    }
}

.special{
    position: absolute;
    top: 16px;
    left: -16px;
    right: auto;
    background: $warning;
    padding: 10px;
    border-radius: 9px;
    color: black;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
}

.specs{
    position: absolute;
    top: 16px;
    left: auto;
    right: -16px;
    background: #23252c;
    padding: 10px;
    border-radius: 9px;
    color: #fff;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);

    .icon{
        margin-right: .4rem;
        width: 16px;
        height: auto;
    }
}

.actions{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    margin-top: -30px;
    opacity: 0;
    transition: opacity .3s;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.caption{
    position: absolute;
    right: -5px;
    bottom: -5px;
    left: -5px;
    padding: 16px 16px 16px 26px;
    background: hsla(0,0%,100%,.9);
    border-radius: 0 0 17px 17px;
    font-size: .9rem;

    .icon{
        background: $primary;
        color: #fff;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: -2px;
        top: 14px;
        transform: translate(-50%);

        .ico{
            width: 18px;
            height: auto;
            fill: white;
        }
    }

    h6{
        font-size: 23px;
    }

    .special{

    }
}

iframe{
    width: 100%;
}

.tags{
    margin-top: .6rem;

    .tag{
        display: inline-block;
        margin-right: .3rem;
        padding: .1rem .3rem;
        background: rgba(black, .1);
        border-radius: .3rem;
        cursor: default;

        .tag-type{
            color: lighten(black, 35%);
        }

        &:hover{
            .tag-type{
                color: black;
            }
            .tag-name{
                color: $feel;
            }
        }
    }
}

</style>
